const isPng = type => {
	return type && (type.includes('.png') || type.includes('.PNG') || type.includes('/png'));
};
const isJpg = type => {
	return (
		type &&
		(type.includes('jpg') ||
			type.includes('.JPG') ||
			type.includes('.jpeg') ||
			type.includes('.JPEG') ||
			type.includes('/jpeg'))
	);
};
const prefixFilename = (original, type, prefix) => {
	if (isPng(type) || isJpg(type)) {
		const chunks = original.split('/');
		chunks[chunks.length - 1] = prefix + chunks[chunks.length - 1];
		return chunks.join('/');
	} else {
		return original;
	}

	// return original
	// 	.split('/')
	// 	.map(chunk => (isPng(chunk) || isJpg(chunk) ? prefix + chunk : chunk))
	// 	.join('/');
};

const getSourcesForJpg = (original, type) => {
	const small = prefixFilename(original, type, '500Kb-');
	const thumbnail = prefixFilename(original, type, '50Kb-');
	return { thumbnail, small, original };
};

const getSourcesForPng = (original, type) => {
	const small = prefixFilename(original, type, 'thumb-');
	return { small, original };
};

export const getSourcesForImage = (original, mimeType) => {
	const type = mimeType || original;
	if (isPng(type)) {
		return getSourcesForPng(original, type);
	} else if (isJpg(type)) {
		return getSourcesForJpg(original, type);
	} else {
		return { original };
	}
};

const prefixPostfixFilename = (original, prefix, postfix) => {
	const chunks = original.split('/');
	chunks[chunks.length - 1] = prefix + chunks[chunks.length - 1] + postfix;
	return chunks.join('/');
};

export const getSourcesForVideo = original => {
	const thumbnail = prefixPostfixFilename(original, 'thumb-', '.gif');
	return { thumbnail, original };
};

export const getSourcesForPdf = original => {
	const thumbnail = prefixPostfixFilename(original, 'thumb-', '.jpeg');
	return { thumbnail, original };
};
